"use client";

/**
 * Anchor that smooth-scrolls to an on-page element by id, computing the target
 * position at click time (robust against layout shift from lazy content /
 * scroll-reveal). Falls back to a normal #hash link if JS is unavailable.
 */
export default function ScrollLink({ targetId, className = "", children, ...rest }) {
  const onClick = (e) => {
    const el = document.getElementById(targetId);
    if (el) {
      e.preventDefault();
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      if (typeof history !== "undefined") {
        history.replaceState(null, "", `#${targetId}`);
      }
    }
  };
  return (
    <a href={`#${targetId}`} onClick={onClick} className={className} {...rest}>
      {children}
    </a>
  );
}
